<div class="value-type-filter">

  <lps-range-input
    #rangeInput
    [minId]="'minValue'"
    [maxId]="'maxValue'"
    [minPrefix]="'R$'"
    [maxPrefix]="'R$'"
    [minPlaceholder]="'Mínimo'"
    [maxPlaceholder]="'Máximo'"
    [mask]="mask"
    [value]="value"
    (valueChange)="emit($event)"
    (onBlur)="sendEvent('valor', $event)"
  ></lps-range-input>

</div>

<ng-template #clearTemplate>
  <span
    class="search-filter__extra"
    [ngClass]="{
      'text-primary': (this.value.min || this.value.max),
      'text-muted': (!this.value.min && !this.value.max)
    }"
    (click)="cleanFilter($event)"
  >
    Limpar Filtros
  </span>
</ng-template>

